// Czech
export const cs = {
    weeklyRewards: 'Týdenní odměny za',
    days: 'dní',
    hours: 'hodin',
    minutes: 'min',
    seconds: 'sek',
    authenticating: 'Ověřování',
    verifyWallet: 'Počkejte prosím, ověřujeme vaši peněženku',
    authRequired: 'Vyžadováno ověření',
    authFailed: 'Ověření selhalo. Prosím zkuste to znovu.',
    points: 'Body',
    rank: 'Pořadí',
    of: 'z',
    players: 'hráčů',
    weeklyTopPlayers: 'Nejlepší hráči týdne',
    thisWeekLeaderboard: 'Žebříček tohoto týdne',
    rankingsReset: 'Žebříček se resetuje každou neděli o půlnoci UTC',
    yourPoints: 'Vaše body',
    dailyRewardAvailable: 'Denní odměna je k dispozici!',
    nextClaimAvailable: 'Další nárok dostupný za:',
    claimDailyReward: 'Získat denní odměnu',
    claiming: 'Získávání...',
    multiplier: 'Násobitel',
    bonusPointsMultiplier: 'Násobitel bonusových bodů',
    outOf: 'z',
    loading: 'Načítání...',
    errorLoading: 'Chyba při načítání',
    noEntries: 'Zatím žádné záznamy',
    leaderboard: 'Žebříček',
    tasks: 'Úkoly',
    rules: 'Pravidla',
    profile: 'Profil',
    comingSoon: 'Již brzy...',
    completedTasks: 'Dokončené úkoly',
    dailyRewardsClaimed: 'Získané denní odměny',
    times: 'krát',
    recentActivity: 'Nedávná aktivita',
    noRewardsClaimed: 'Zatím nebyly získány žádné odměny',
    dailyReward: 'Denní odměna',
    howItWorks: 'Jak to funguje',
    welcomeMessage:
        'Vítejte v Coinomi Rewards! Získávejte body plněním různých úkolů a stoupejte v žebříčku.',
    dailyRewardsTitle: 'Denní odměny',
    dailyRewardsRules: [
        'Získejte denní odměnu každých 24 hodin',
        'Každé získání přináší 100 bodů',
        'Body se násobí podle vašeho násobitele',
    ],
    multiplierBonusesTitle: 'Bonusové násobitele',
    multiplierBonusesRules: [
        'Začněte s 1x násobitelem',
        'Připojte Telegram pro +10% bonus',
        'Ověřte email pro +10% bonus',
        'Bonusy se sčítají pro maximální odměny',
    ],
    leaderboardTitle: 'Žebříček',
    leaderboardRules: [
        'Soutěžte s ostatními hráči',
        'Žebříček se aktualizuje v reálném čase',
        'Nejlepší hráči získávají speciální odměny',
    ],
    boostEarningsTitle: 'Zvyšte své výdělky',
    boostEarningsRules: [
        'Plňte výzvy pro získání bonusů',
        'Připojte se k naší Telegram komunitě',
        'Zůstaňte aktivní pro maximální odměny',
    ],
    challenges: 'Výzvy',
    telegramChallenge: 'Telegram výzva',
    emailChallenge: 'Email výzva',
    connectTelegram: 'Připojit Telegram',
    shareEmail: 'Sdílet email',
    telegramSuccess: '🎉 Gratulujeme! Nyní získáváte trvalý 10% bonus na všechny odměny!',
    telegramPrompt:
        'Propojte svůj Telegram účet pro získání trvalého 10% bonusu na všechny odměny!',
    emailSuccess: '🎉 Gratulujeme! Nyní získáváte trvalý 10% bonus na všechny odměny!',
    emailPrompt: 'Sdílejte svůj email pro získání trvalého 10% bonusu na všechny odměny!',
    connectEmail: 'Připojit email',
    cancel: 'Zrušit',
    emailPrivacy: 'Váš email použijeme pouze pro důležité aktualizace a oznámení o odměnách.',
    connectYourEmail: 'Připojte svůj email',
    emailBonus: '🎉 Získejte trvalý 10% bonus na všechny odměny připojením emailu!',
    enterValidEmail: 'Prosím zadejte platnou emailovou adresu',
    emailAddress: 'Emailová adresa',
    errorSavingEmail: 'Chyba při ukládání emailu. Prosím zkuste to znovu.',
    claimButton: 'Získat',
    earnedReward: 'Získaná odměna',
    rewardValue: '{{amount}} Bodů',
    claimingReward: 'Získávání...',
    claimSuccess: 'Úspěšně získáno {{amount}} bodů!',
    claimError: 'Nepodařilo se získat odměnu. Prosím zkuste to znovu.',
    privacyDisclaimer:
        'Coinomi neshromažďuje osobní údaje; systém třetí strany bezpečně spravuje body a sociální propojení.',
    streakBonus: 'Bonus za sérii',
    streakDays: '{{days}}/5 Dní',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Navíc',
    streakDescription: 'Získejte odměnu 5 dní v řadě pro maximální bonus',
    streakToday: 'Dnes',
    streakMissed: 'Zmeškáno',
    streakComplete: 'Dokončeno',
    streakActive: 'Aktivní série',
    streakLost: 'Série ztracena',
    streakNext: 'Další',
    home: 'Domů',
    currentStreak: 'Aktuální série',
    totalClaims: 'Celkem získáno',
    userStats: 'Vaše statistiky',
    referrals: 'Doporučení',
    referralProgram: 'Program doporučení',
    howReferralWorks: 'Jak fungují doporučení:',
    referralSteps: [
        'Sdílejte svůj doporučující odkaz s přáteli',
        'Když se připojí pomocí vašeho odkazu, stanou se vaším doporučením',
        'Získejte bonusové body za každé aktivní doporučení',
        'Sledujte svá doporučení a výdělky zde',
    ],
    referralRewards: 'Body za doporučení se udělují:',
    referralBonuses: ['100 bodů za každé doporučení', '10% ze všech bodů, které doporučený získá'],
    yourReferralLink: 'Váš doporučující odkaz',
    copyToClipboard: 'Kopírovat do schránky',
    linkCopied: 'Odkaz zkopírován do schránky!',
    totalReferrals: 'Celkem doporučení',
    yourReferralCode: 'Váš doporučující kód',
    referralCodeCopied: 'Doporučující kód zkopírován!',
    editReferralCode: 'Upravit doporučující kód',
    editReferralCodeInstructions:
        'Zvolte nový doporučující kód. Musí mít alespoň 5 znaků a může obsahovat písmena a čísla.',
    newReferralCode: 'Nový doporučující kód',
    referralCodeRequirements: 'Minimálně 5 znaků, pouze písmena a čísla',
    updating: 'Aktualizace...',
    update: 'Aktualizovat',
    referralCodeTaken: 'Tento doporučující kód je již obsazen',
    haveReferralCode: 'Máte doporučující kód?',
    enterReferralCodePrompt:
        'Pokud vás někdo doporučil, zadejte zde jejich kód pro propojení účtů.',
    enterReferralCode: 'Zadejte doporučující kód',
    enterReferralCodeInstructions: 'Zadejte doporučující kód, který vám byl sdílen.',
    referralCode: 'Doporučující kód',
    referralCodeFormat: 'Pouze písmena a čísla',
    submitting: 'Odesílání...',
    submit: 'Odeslat',
    enterCode: 'Zadejte kód',
    pleaseAddtoken: 'Prosím přidejte token parametr do URL',
    authenticationError: 'Při ověřování došlo k chybě',
    noUserFound: 'Uživatel nenalezen',
    userNotFoundMessage: 'Nelze najít data uživatele',
    backToHome: 'Zpět na hlavní stránku',
    retry: 'Zkusit znovu',
    baseMultiplier: 'Základní násobitel',
    telegramBonus: 'Telegram bonus',
    referralChallenge: 'Výzva doporučení',
    referralChallengePrompt:
        'Pozvěte přátele a získejte bonusové body! Získejte 100 bodů za každé doporučení plus 10% z jejich výdělků.',
    startReferring: 'Začít doporučovat',
    referralSuccess: '🎉 Gratulujeme! Úspěšně jste doporučili uživatele a získáváte bonusové body!',
    unranked: 'Bez hodnocení',
    noPlayersYet: 'Buďte první, kdo se připojí!',
    shareVia: 'Sdílet přes',
    shareOn: 'Sdílet na {{network}}',
    shareInviteText:
        '🚀 Vydělávám zdarma krypto s @CoinomiWallet!\n\nStáhněte Coinomi z coinomi.com/downloads a zadejte můj doporučovací kód {{referralCode}}, abyste získali bonus při připojení k #Coinomi Rewards v aplikaci.',
    yourStatsThisWeek: 'Vaše statistiky tento týden',
    pointsMultiplier: 'Násobitel bodů',
    yourRank: 'Vaše pořadí',
    rewards: 'Odměny',
    daily: 'Denní',
    weekly: 'Týdenní',
    claimRewards: 'Získat odměny',
    copy: 'Kopírovat',
    // Twitter Challenge
    twitterChallenge: 'Twitter Výzva',
    connectTwitter: 'Připojit Twitter',
    twitterSuccess: '🎉 Gratulujeme! Nyní získáváte 10% trvalý bonus na všechny odměny!',
    twitterPrompt: 'Připojte svůj Twitter účet a získejte 10% trvalý bonus na všechny odměny!',
    pleaseAddUserId: 'Please add a userId parameter to the URL',
    emailChallengePrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    emailChallengeSuccess:
        '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    followKoalaWalletChallenge: 'Follow @coinomiWallet on Twitter to support us!',
    twitterAuthSuccessTitle: 'Twitter Connected Successfully!',
    twitterAuthSuccessMessage:
        'You have successfully connected your Twitter account. You can now continue using the app.',
    continueToApp: 'Continue to App',
    twitter_like: 'Liked a tweet',
    twitter_retweet: 'Retweeted a tweet',
    disconnect: 'Odpojit',
    followCoinomiWallet: 'Sledujte @coinomiWallet na Twitteru a podpořte nás!',
    connectedBonus: '🎉 Připojeno! Nyní získáváte trvalý 10% bonus na všechny odměny!',
};
